import { render, staticRenderFns } from "./WidgetFilterLocale.vue?vue&type=template&id=f3c6cb22&scoped=true"
import script from "./WidgetFilterLocale.vue?vue&type=script&lang=ts"
export * from "./WidgetFilterLocale.vue?vue&type=script&lang=ts"
import style0 from "./WidgetFilterLocale.vue?vue&type=style&index=0&id=f3c6cb22&prod&scoped=true&lang=scss"
import style1 from "./WidgetFilterLocale.vue?vue&type=style&index=1&id=f3c6cb22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c6cb22",
  null
  
)

export default component.exports